import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const yearStromGesamtReducer = (state = {
    BarYearStromGesamtUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_BarYearStromGesamt_yearStromGesamtReducer":
            return { ...state, BarYearStromGesamtUI: action.value, isLoaded: true };
        // Bei forceRefresh/Neuladen: Alte Daten sofort leeren damit Chart Skeleton zeigt!
        case requestTypes.requestStartType.type:
            return { ...state, BarYearStromGesamtUI: [], isLoaded: false };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default yearStromGesamtReducer;
